import {
  jb_play_pause_button_css_default
} from "./chunk.LWTEJI5O.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.YAATWOBE.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  attachInterestEvents
} from "./chunk.AHMM4X2O.js";
import {
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-play-pause-button/jb-play-pause-button.ts
var JbPlayPauseButton = class extends i {
  constructor() {
    super(...arguments);
    this.spriteSvgUrl = "";
    this._hovering = false;
    this._playing = false;
  }
  async connectedCallback() {
    super.connectedCallback();
    await this.updateComplete;
    attachInterestEvents(this._mediaButton);
  }
  setMediaElement(mediaElement) {
    this._mediaElement = mediaElement;
    this._mediaElement.addEventListener("play", () => {
      this._playing = true;
    });
    this._mediaElement.addEventListener("pause", () => {
      this._playing = false;
    });
    this._mediaElement.addEventListener("ended", () => {
      this._playing = false;
    });
  }
  _click() {
    if (!this._mediaElement) {
      return;
    }
    this._playing = !this._playing;
    if (this._playing) {
      this._mediaElement.play();
    } else {
      this._mediaElement.pause();
    }
  }
  render() {
    return b`<button
      aria-label="${this._playing ? this.ariaLabelPause ?? "Pause" : this.ariaLabelPlay ?? "Play"}"
      aria-pressed="${this._playing ? "true" : "false"}"
      @click=${this._click}
      class=${e2({ playing: this._playing })}
      @interest=${() => {
      this._hovering = true;
    }}
      @loseinterest=${() => {
      this._hovering = false;
    }}
    >
      <jb-icon
        commonAnimation="scale_increase"
        class="${e2({ hover: this._hovering })}"
        iconName="material:play_arrow-fill"
      ></jb-icon>
      <jb-icon
        commonAnimation="scale_increase"
        class="${e2({ hover: this._hovering })}"
        iconName="material:pause-fill"
      ></jb-icon>
    </button>`;
  }
};
JbPlayPauseButton.styles = [reset_css_default, jb_play_pause_button_css_default];
__decorateClass([
  n()
], JbPlayPauseButton.prototype, "ariaLabelPause", 2);
__decorateClass([
  n()
], JbPlayPauseButton.prototype, "ariaLabelPlay", 2);
__decorateClass([
  n()
], JbPlayPauseButton.prototype, "spriteSvgUrl", 2);
__decorateClass([
  r()
], JbPlayPauseButton.prototype, "_hovering", 2);
__decorateClass([
  e("button")
], JbPlayPauseButton.prototype, "_mediaButton", 2);
__decorateClass([
  r()
], JbPlayPauseButton.prototype, "_playing", 2);
JbPlayPauseButton = __decorateClass([
  customElement("jb-play-pause-button")
], JbPlayPauseButton);

export {
  JbPlayPauseButton
};
